import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0M4.5 4.5V9L8 12.5L11.5 9V4.5L8 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownChevronCircle
